import { render, staticRenderFns } from "./RequestFeedList.vue?vue&type=template&id=2d97bfb9&"
import script from "./RequestFeedList.vue?vue&type=script&lang=js&"
export * from "./RequestFeedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports